<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Trip Companions</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen v-if="toLoad" message="Loading companion statistics…" />
        <section v-else class="max-width-container">
            <ul class="highlight-boxes">
                <li>
                    <span>most trips</span>
                    <span>{{ summary.trips }}</span>
                </li>
                <li>
                    <span>most days</span>
                    <span>{{ summary.days }}</span>
                </li>
                <li>
                    <span>most countries</span>
                    <span>{{ summary.countries }}</span>
                </li>
            </ul>
        </section>
        <section v-if="!toLoad" class="stat-blocks max-width-container">
            <article>
                <h2>Leaderboard</h2>
                <h3>Trips</h3>
                <BaseChart name="Trips" :options="tripsChart" />
                <h3>Days</h3>
                <BaseChart name="Days" :options="daysChart" />
                <DataTable :table="yoy" unsortable />
            </article>
        </section>
        <section v-if="!toLoad" class="stat-blocks max-width-container">
            <article>
                <h2>Companions</h2>
                <DataTable row-numbers="cup" :sort-column="-1" :table="table" />
            </article>
        </section>
        <section class="actions">
            <router-link to="/stats">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import DataTable from "js/components/tables/DataTable";
import BaseChart from "js/components/charts/BaseChart";
import LoadingScreen from "js/components/common/LoadingScreen";
import { fetch } from "js/lib/server.js";
import { getChart } from "js/lib/charts.js";

export default {
    components: {
        LoadingScreen,
        DataTable,
        BaseChart,
    },
    data() {
        return {
            toLoad: -99,
            table: null,
            tripsChart: null,
            daysChart: null,
            summary: null,
        };
    },
    mounted() {
        this.toLoad = -2;
        fetch("/api/stats/companions").then((response) => {
            this.table = response.data.table;
            this.summary = response.data.summary;
            this.toLoad++;
        });

        fetch("/api/stats/companions/yoy").then((response) => {
            this.yoy = response.data.table;
            this.tripsChart = getChart(
                "line",
                response.data.charts.trips.labels,
                Object.keys(response.data.charts.trips.lines).reduce(
                    (data, label) => {
                        data.push({
                            label,
                            data: response.data.charts.trips.lines[label],
                        });
                        return data;
                    },
                    []
                )
            );
            this.daysChart = getChart(
                "line",
                response.data.charts.trips.labels,
                Object.keys(response.data.charts.days.lines).reduce(
                    (data, label) => {
                        data.push({
                            label,
                            data: response.data.charts.days.lines[label],
                        });
                        return data;
                    },
                    []
                )
            );
            this.toLoad++;
        });
    },
};
</script>
